import {
  deleteAdminV1StoresStoreIdSalesIdLotsAuctionId,
  getAdminV1StoresStoreIdSales,
  getAdminV1StoresStoreIdSalesId,
  patchAdminV1StoresStoreIdSalesId,
  patchAdminV1StoresStoreIdSalesIdLotsOrder,
  postAdminV1StoresStoreIdSales,
  postAdminV1StoresStoreIdSalesIdCancel,
  postAdminV1StoresStoreIdSalesIdLots,
  postAdminV1StoresStoreIdSalesIdSchedule,
  type AdminAuctionSale,
  type GetAdminV1StoresStoreIdSales200,
  type GetAdminV1StoresStoreIdSalesParams,
  type PatchAdminV1StoresStoreIdSalesIdBody,
  type PostAdminV1StoresStoreIdSalesBody,
} from '@nucleus-commerce/api-client/admin';

export type SaleListParams = GetAdminV1StoresStoreIdSalesParams;

/**
 * Sales of one store (D-179): a titled group of lots that close one after another from the first
 * close time. The schedule, interval and premium change only while the sale is a draft; the
 * editorial fields change in any status. Every write answers the whole sale.
 */
export const salesApi = {
  list: (storeId: string, params: SaleListParams): Promise<GetAdminV1StoresStoreIdSales200> =>
    getAdminV1StoresStoreIdSales({ storeId }, params),
  get: (storeId: string, id: string): Promise<AdminAuctionSale> =>
    getAdminV1StoresStoreIdSalesId({ storeId, id }),
  create: (storeId: string, body: PostAdminV1StoresStoreIdSalesBody): Promise<AdminAuctionSale> =>
    postAdminV1StoresStoreIdSales({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdSalesIdBody,
  ): Promise<AdminAuctionSale> => patchAdminV1StoresStoreIdSalesId({ storeId, id }, body),
  /** Numbers the lots, gives each its close time and schedules every one of them. */
  schedule: (storeId: string, id: string): Promise<AdminAuctionSale> =>
    postAdminV1StoresStoreIdSalesIdSchedule({ storeId, id }),
  cancel: (storeId: string, id: string, reason: string): Promise<AdminAuctionSale> =>
    postAdminV1StoresStoreIdSalesIdCancel({ storeId, id }, { reason }),
  addLot: (storeId: string, id: string, auctionId: string): Promise<AdminAuctionSale> =>
    postAdminV1StoresStoreIdSalesIdLots({ storeId, id }, { auctionId }),
  reorderLots: (storeId: string, id: string, auctionIds: string[]): Promise<AdminAuctionSale> =>
    patchAdminV1StoresStoreIdSalesIdLotsOrder({ storeId, id }, { auctionIds }),
  removeLot: (storeId: string, id: string, auctionId: string): Promise<AdminAuctionSale> =>
    deleteAdminV1StoresStoreIdSalesIdLotsAuctionId({ storeId, id, auctionId }),
};
